import worthyApi from 'lib/api/worthyApi';

export const GET_WORTHY_STATS  = Symbol('GET_WORTHY_STATS');
export const GET_LIVE_AUCTIONS = Symbol('GET_LIVE_AUCTIONS');
export const GET_RECENT_DEALS  = Symbol('GET_RECENT_DEALS');

export function getHomePageWorthStats() {
  let request = worthyApi.getHomePageWorthStats().
      then(res => res.data).
      catch((error) => {
        throw error;
      });

  return {
    type: GET_WORTHY_STATS,
    payload: request,
  };
}

export function getLiveAuctions() {
  let request = worthyApi.getLiveAuctions().
      then(res => res.data).
      catch((error) => {
        throw error;
      });

  return {
    type: GET_LIVE_AUCTIONS,
    payload: request,
  };
}

export function getRecentDeals(params) {
  let request = worthyApi.getRecentDeals(params)
      .then(res => res.data)
      .catch(error => {
        throw error;
      });

  return {
    type: GET_RECENT_DEALS,
    payload:request
  }
}